<template>
  <div class="form-group row">
    <label
      for="checkActive"
      class="col-4 col-form-label">Активность техцентра
    </label>
    <div class="col-8">
      <label class="switch switch-lg switch-3d switch-primary mr-1">
        <input
          id="checkActive"
          v-model="enabled"
          class="switch-input"
          type="checkbox"
          @click="$emit('input', !enabled)">
        <span class="switch-label"></span>
        <span class="switch-handle"></span>
        <small v-if="enabled">включен</small>
        <small v-else>выключен</small>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TcCheckBox',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      enabled: this.value
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TcCheckBox.vue?4d1e4b92